import React, { useState } from "react";
import { FaCheckCircle, FaTimes, FaGlobe, FaLock } from "react-icons/fa";

export default function ProcessComplaintModal({ isOpen, onClose, onConfirm, loading }) {
    const [response, setResponse] = useState("");
    const [markPublic, setMarkPublic] = useState(false);

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        onConfirm({ response, markPublic });
    };

    return (
        <div className="modal-overlay shadow">
            <div className="modal-content-custom rounded-4 shadow-lg border-0">
                <div className="modal-header border-bottom p-3 d-flex justify-content-between align-items-center bg-light rounded-top-4">
                    <h5 className="mb-0 fw-bold text-dark">معالجة الشكوى</h5>
                    <button className="btn-close" onClick={onClose}></button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="modal-body p-4">
                        <div className="mb-4">
                            <label className="form-label fw-bold small text-muted">رد الإدارة على الشكوى</label>
                            <textarea
                                className="form-control border-2 rounded-3"
                                rows="5"
                                required
                                value={response}
                                onChange={(e) => setResponse(e.target.value)}
                                placeholder="اكتب تفاصيل المعالجة هنا..."
                            ></textarea>
                        </div>

                        <div className="bg-light p-3 rounded-3 border">
                            <div className="form-check form-switch d-flex align-items-center justify-content-between p-0">
                                <div>
                                    <label className="form-check-label fw-bold d-block">جعل الشكوى عامة</label>
                                    <small className="text-muted">سيتمكن الزوار من رؤية الشكوى</small>
                                </div>
                                <input
                                    className="form-check-input ms-0"
                                    type="checkbox"
                                    checked={markPublic}
                                    onChange={(e) => setMarkPublic(e.target.checked)}
                                    style={{ width: '2.5em', height: '1.25em', cursor: 'pointer' }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer border-top p-3 bg-light rounded-bottom-4">
                        <button type="button" className="btn btn-secondary rounded-pill px-4" onClick={onClose} disabled={loading}>إلغاء</button>
                        <button type="submit" className="btn btn-success rounded-pill px-4 fw-bold" disabled={loading}>
                            {loading ? <span className="spinner-border spinner-border-sm me-2"></span> : <FaCheckCircle className="ms-2" />}
                            تأكيد المعالجة
                        </button>
                    </div>
                </form>
            </div>
            <style>{`
                .modal-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.6); z-index: 10000; display: flex; align-items: center; justify-content: center; backdrop-filter: blur(4px); }
                .modal-content-custom { background: white; width: 500px; max-width: 95%; position: relative; animation: slideUp 0.3s ease-out; }
                @keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
            `}</style>
        </div>
    );
}